module.exports = __webpack_public_path__ + "static/media/chapters.f2c4ab8d.jpg";